
import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import { PanelRow, RangeControl, __experimentalUnitControl as UnitControl } from '@wordpress/components';
import { BDevice, Label } from '../../../../Components';
import { emUnit, perUnit, pxUnit } from '../../../../Components/utils/options';
import Row from '../../settings/Components/Row/Row';
import Column from '../../settings/Components/Column/Column';

const GridLayoutPanel = ({ setData, data }) => {
    console.log(data);
    const { columns = { desktop: 3, tablet: 2, mobile: 1 }, columnGap = "30px", rowGap = "40px" } = data;
    const [device, setDevice] = useState();

    return <>

        <PanelRow>
            <Label mt='0'>{__('Columns:', 'swipe-n-buy')}</Label>
            <BDevice device={device} onChange={val => setDevice(val)} />
        </PanelRow>

        <RangeControl value={columns[device]} onChange={val => { setData({ ...data, columns: { ...columns, [device]: val } }); }} min={1} max={6} step={1} beforeIcon='grid-view' />
        <Row>
            <Column span={6}>
                <UnitControl className='mt10' label={__('Column Gap:', 'swipe-n-buy')} labelPosition='left' value={columnGap} onChange={val => setData({ ...data, columnGap: val })} units={[pxUnit(30), perUnit(3), emUnit(2)]} isResetValueOnUnitChange={true} />
            </Column>

            <Column span={6}>
                <UnitControl className='mt10' label={__('Row Gap:', 'swipe-n-buy')} labelPosition='left' value={rowGap} onChange={val => setData({ ...data, rowGap: val })} units={[pxUnit(40), perUnit(3), emUnit(2.5)]} isResetValueOnUnitChange={true} />
            </Column>

        </Row>

    </>
}
export default GridLayoutPanel;